import axiosInstance from '../axios.instance';

export const signUpApi = (email) => axiosInstance.post('/auth/registration', { email });

export const signInApi = (data) => axiosInstance.post('/auth/login', data);
